export default class ChordParsingError extends Error {}
